import {
  observable,
  action
} from 'mobx';
import {
  message
} from 'antd';
import base from '../../tool/base';
import util from '../../util/index';

const {
  catchApiError,
  getAccessToken,
} = util;
message.config({
  top: 20,
});
export class AppDetailStore {

  routing = null;

  constructor(routing) {
    this.routing = routing;
  }

  @observable dbs = [];
  @observable dbsReply = [];
  @observable dbsCount = 0;
  @observable current = 1;
  @observable pageSize = 5;
  @observable addLoading = false;

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }

  @action
  getDeb = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
    };
    return new Promise(resolve => {
      base.callApi(`/v1/deb/${params.sw_id}`, 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status !== 'false') {
          this.dbs = data.dbs;
          this.dbsReply = data.dbsreply;
          this.dbsCount = data.count;
          this.current = param.current;
        }
        resolve(data);
      });
    });
  }

  @action
  addDeb = (params = {}) => {
    this.addLoading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi(`/v1/deb/${params.sw_id}/add`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        this.getDeb({
          current: 1,
          sw_id: param.sw_id,
          s_number: param.s_number
        });
        this.addLoading = false;
        resolve(data);
      });
    });
  }

}


// WEBPACK FOOTER //
// ./src/stores/modeList/appDetailStore.js